import { RootState } from 'redux/reducers/rootReducer';

const myApprovedClientsSelector = (state: RootState) =>
  state.client.approvedClients;
const clientCreatedAtSelector = (state: RootState) =>
  state.client.clientCreatedAt;
const clientDraftCreatedAtSelector = (state: RootState) =>
  state.client.clientDraftCreatedAt;
const clientDetailsSelector = (state: RootState) => state.client.clientDetails;
const isMemberAdditionalInfoVisibleSelector = (state: RootState) =>
  state.client.isMemberAdditionalInfoVisible;
const isClientModalOpenSelector = (state: RootState) =>
  state.client.isClientModalOpen;
const customerDetailsUpdatedAtByAdminSelector = (state: RootState) =>
  state.client.customerDetailsUpdatedAtByAdmin;
const customerGroupsSelector = (state: RootState) =>
  state.client.customerGroups;

export {
  clientCreatedAtSelector,
  myApprovedClientsSelector,
  clientDraftCreatedAtSelector,
  clientDetailsSelector,
  isMemberAdditionalInfoVisibleSelector,
  isClientModalOpenSelector,
  customerDetailsUpdatedAtByAdminSelector,
  customerGroupsSelector,
};
